import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'store';
var Container = styled.div.withConfig({
  displayName: "FAQList__Container",
  componentId: "sc-47386w-0"
})(["@media (min-width:786px){.faq-li{min-width:600px;}}"]);

var FAQList = function FAQList() {
  var faqs = useSelector(function (state) {
    return state.site.faqs;
  });

  var onClickFaq = function onClickFaq(e) {
    if (e.target.tagName === 'A') {
      var text = e.target.text;
      clearFaqSelected(text);
    } else {
      clearLISelected();
      e.target.className = 'selected';
    }
  };

  var clearFaqSelected = function clearFaqSelected(text) {
    var faq_list = document.getElementById('faq-list');
    faq_list.querySelectorAll('li').forEach(function (el) {
      var atag = el.firstElementChild;

      if (atag.textContent === text) {
        el.className = 'selected';
      } else {
        el.classList.remove('selected');
      }
    });
  };

  var clearLISelected = function clearLISelected() {
    var faq_list = document.getElementById('faq-list');
    faq_list.querySelectorAll('li').forEach(function (el) {
      el.classList.remove('selected');
    });
  };

  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "faq-li",
      children: [/*#__PURE__*/_jsx("h2", {
        children: "FAQ"
      }), /*#__PURE__*/_jsx("ul", {
        id: "faq-list",
        children: faqs.results.map(function (faq) {
          if (faq.is_expose) {
            return /*#__PURE__*/_jsxs("li", {
              style: {
                cursor: 'pointer'
              },
              onClick: onClickFaq,
              children: [/*#__PURE__*/_jsx("a", {
                children: faq.title
              }), /*#__PURE__*/_jsx("div", {
                children: faq.description
              })]
            }, faq.id);
          }
        })
      })]
    })
  });
};

export default FAQList;